import { VersionUpdateBanner } from 'components/common/VersionUpdateBanner';
import { CreditProvider, EligibilityProvider } from 'hooks';
import { LocalizationContext } from 'localization/LocalizationContext';
import { Router } from 'router';
import {
  PosthogProvider,
  AuthProvider,
  ApiInterceptorProvider,
  TanstackQueryProvider,
  SnackbarProvider,
  AntdProvider,
  MuiProvider,
} from './providers';

export const App = () => {
  return (
    <PosthogProvider>
      <AuthProvider>
        <ApiInterceptorProvider>
          <TanstackQueryProvider>
            <MuiProvider>
              <EligibilityProvider>
                <CreditProvider>
                  <LocalizationContext>
                    <SnackbarProvider>
                      <AntdProvider>
                        <VersionUpdateBanner />
                        <Router />
                      </AntdProvider>
                    </SnackbarProvider>
                  </LocalizationContext>
                </CreditProvider>
              </EligibilityProvider>
            </MuiProvider>
          </TanstackQueryProvider>
        </ApiInterceptorProvider>
      </AuthProvider>
    </PosthogProvider>
  );
};
